module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "chatSoundSpeaker.6c2bf746.png";